import React from "react";
import { Notice } from "../../common/cards/Notice";
import { KTSVG } from "../../../_metronic/helpers";

interface EmailSentNoticeProps {
  email: string;
  /** Shows a "Resend" link that calls this instead of just leaving the confirmation static. */
  onResend?: () => void;
}

export function EmailSentNotice({ email, onResend }: EmailSentNoticeProps) {
  return (
    <div className="">
      <div className="card-body">
        <div className="text-center mb-11">
          <div className="text-dark fs-1 fw-bolder mb-3">Check Your Email</div>

          <Notice
            noticeClasses="notice d-flex bg-light-success rounded border-success border-dashed p-6 mb-7"
            button={null}
            header={null}
            content={
              <>
                <div className="text-center">
                  <div className="fs-4 fw-bold mb-3">
                    Sign-in link sent to {email}
                  </div>
                  <div className="text-gray-800 fw-semibold fs-6">
                    We've sent a sign-in link to your email address. Please
                    check your inbox and click the link to sign in.
                  </div>
                </div>
              </>
            }
            icon={null}
            iconClasses={null}
            centerText={true}
          />

          {onResend && (
            <button
              type="button"
              className="btn btn-link p-0 fw-semibold text-decoration-underline"
              onClick={onResend}
            >
              Wrong email, or didn't get it? Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
